import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    CircularProgress,
    Grid, Paper,
    Stack,
    TextField,
    InputAdornment,
    Typography
} from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import SearchIcon from '@mui/icons-material/Search';
import ServiceOrderCard from "../ServiceOrderCard";
import {useEffect, useState} from "react";
import axios from "../../axiosConfig";

const ServiceOrder = () => {
    const [services, setServices] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        axios.get("/MunicipalityService/MunicipalityServices").then(res => {
            setIsLoading(false)
            setServices(res);
        }).catch(e => {
            setIsLoading(false)
        });
    }, []);
    if (isLoading) {
        return (
            <Box sx={{mt: 15, textAlign: "center"}}>
                <CircularProgress size={80}/>
            </Box>
        )
    }

    const isSearching = searchQuery.trim().length > 0;

    const filteredServices = services
        .map(t => ({
            ...t,
            publicServices: t.publicServices.filter(f =>
                f.name?.toLowerCase().includes(searchQuery.toLowerCase())
            ),
        }))
        .filter(t => t.publicServices.length > 0);

    return (
        <Paper sx={{p: 3, background: "#F9FAFC"}} elevation={5}>
            <Stack gap={3}>
                <TextField
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="ابحث عن خدمة..."
                    variant="outlined"
                    fullWidth
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon color="primary" />
                            </InputAdornment>
                        ),
                    }}
                    sx={{ backgroundColor: "#fff", borderRadius: 2 }}
                />

                {isSearching && filteredServices.length === 0 && (
                    <Box sx={{ textAlign: "center", py: 4 }}>
                        <Typography color="text.secondary">
                            لا توجد خدمات تطابق "{searchQuery}"
                        </Typography>
                    </Box>
                )}

                {filteredServices.map(t => (
                    <Accordion key={t.name} defaultExpanded={isSearching}>
                        <AccordionSummary expandIcon={<ArrowDropDownIcon color="primary"/>}>
                            <Typography sx={{fontWeight: "bold"}} variant="h6" color="primary.main">
                                {t.name}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid spacing={3} container>
                                {t.publicServices.map(f => (
                                    <Grid item lg={4} md={6} xs={12} key={f.name}>
                                        <ServiceOrderCard pageName="/service-request" {...f} groupName={t.name} name={f.name} isForCitizen={true}/>
                                    </Grid>
                                ))}
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </Stack>
        </Paper>
    )
}
export default ServiceOrder